import { AlertHandlingActions } from '@/store/actions';
import { alert } from '@/services/alertService';
export default {
	methods: {
		alert(message, type) {
			this.$store.dispatch(
				AlertHandlingActions.SET_ALERT,
				alert(message, type)
			);
		},
	},
};
